import { fetchWebhooks, fetchKappWebhookEvents, fetchSpaceWebhookEvents } from '../../../apis';
import { generateTable } from '../../table/Table';
import { defineFilter } from '../../../helpers';
import { List, Map } from 'immutable';
var clientSide = defineFilter(true).startsWith('name', 'name').equals('type', 'type').equals('event', 'event').end();

var dataSource = function dataSource(_ref) {
  var scope = _ref.scope,
      kappSlug = _ref.kappSlug;
  return {
    fn: fetchWebhooks,
    clientSide: clientSide,
    params: function params() {
      return [{
        include: 'details',
        scope: scope,
        kappSlug: kappSlug
      }];
    },
    transform: function transform(result) {
      return {
        data: result.webhooks
      };
    }
  };
};

var filterDataSources = function filterDataSources(_ref2) {
  var kappSlug = _ref2.kappSlug;
  return {
    events: {
      fn: kappSlug ? fetchKappWebhookEvents : fetchSpaceWebhookEvents,
      params: [],
      transform: function transform(result) {
        return result;
      }
    }
  };
};

var filters = function filters() {
  return function (_ref3) {
    var events = _ref3.events,
        values = _ref3.values;
    return events && [{
      name: 'name',
      label: 'Name',
      type: 'text'
    }, {
      name: 'type',
      label: 'Type',
      type: 'select',
      options: function options(_ref4) {
        var events = _ref4.events;
        return events ? events.keySeq().sort().map(function (type) {
          return Map({
            label: type,
            value: type
          });
        }) : List();
      },
      onChange: function onChange(_ref5, _ref6) {
        var values = _ref5.values;
        var setValue = _ref6.setValue;

        if (values.get('event')) {
          setValue('event', '');
        }
      }
    }, {
      name: 'event',
      label: 'Event',
      type: 'select',
      options: function options(_ref7) {
        var values = _ref7.values,
            events = _ref7.events;
        return values && events ? events.get(values.get('type'), List()).map(function (event) {
          return Map({
            label: event,
            value: event
          });
        }) : List();
      }
    }];
  };
};

var columns = [{
  value: 'createdAt',
  title: 'Created'
}, {
  value: 'createdBy',
  title: 'Created By'
}, {
  value: 'event',
  title: 'Event'
}, {
  value: 'filter',
  title: 'Filter'
}, {
  value: 'name',
  title: 'Name'
}, {
  value: 'type',
  title: 'Type'
}, {
  value: 'updatedAt',
  title: 'Updated'
}, {
  value: 'updatedBy',
  title: 'Updated By'
}, {
  value: 'url',
  title: 'URL'
}];
export var WebhookTable = generateTable({
  tableOptions: ['scope', 'kappSlug'],
  columns: columns,
  filters: filters,
  filterDataSources: filterDataSources,
  dataSource: dataSource
});
WebhookTable.displayName = 'WebhookTable';